import DEFAULT_FILLED_INPUT_CLASS_NAME from '../../constants/filled-input';

const getDefaultFilledInputStyles = ({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
  '&:after': {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
});

const MuiFilledInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      backgroundColor: theme.palette.gray.A100,
      '&:before': {
        border: 0,
      },
      '&:hover:before': {
        border: 0,
      },
      height: 47,
      [`&.${DEFAULT_FILLED_INPUT_CLASS_NAME}`]: getDefaultFilledInputStyles({ theme }),
    }),
    input: {
      paddingTop: 10,
      paddingBottom: 0,
      lineHeight: '40px',
      display: 'flex',
      alignItems: 'center',
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
        WebkitBackgroundClip: 'text',
      },
    },
    adornedEnd: {
      height: 47,
      display: 'flex',
      alignItems: 'center',
    },
  },
};

export default MuiFilledInput;
